export default __webpack_public_path__ + "static/media/angpao.46a9ce7a.webp";